import React from "react";
import githubb from "../assets/githubb.svg";
import external from "../assets/external.svg";
import { motion } from "framer-motion";
// import img1 from "../assets/image1.png";

function Projects(props) {
  return (
    <motion.div
      className="md:h-screen mb-[50px] md:mb-0  "
      initial={{ x: "-100vh", opacity: 0.1 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ type: "spring", delay: 0.5, stiffness: 120 }}
    >
      {/* project showcase */}
      <div className="flex relative  " id={props.id}>
        {/* left flex */}
        <a
          href={props.host}
          target="_blank"
          rel="noreferrer"
          className="md:w-[600px] w-[250px] bg-[#1d4652] md:h-[400px] h-[250px] mx-auto md:mx-0"
        >
          <img
            src={props.img}
            alt=""
            className="h-full md:opacity-[1] opacity-[0.1] "
          />
        </a>
        {/* right flex */}
        <div className="md:self-center flex flex-col gap-2 md:gap-4 absolute top-[15px] md:top-0 md:left-0 left-[4rem]   md:relative  ">
          <div className="md:self-end self-start flex flex-col">
            <h6 className="md:self-end self-start text-xs md:text-base">
              Featured Project
            </h6>
            <h1 className="md:self-end self-start font-bold text-xl  md:text-4xl ">
              {props.name}
            </h1>
          </div>
          {/* project description */}
          <div className=" text-justify md:w-[450px] w-[250px] md:h-[150px] md:bg-[#112240] md:p-[20px] p-[5px] overflow-hidden ">
            <p className="container w-[80%] md:w-auto text-xs md:text-sm md:h-auto h-[80px]  ">
              {props.description}
            </p>
          </div>
          <div>
            <ul className="flex md:gap-4 gap-[4px] justify-start md:justify-end text-xs md:text-base ">
              {props.tools.map((tool) => (
                <li key={tool}>{tool}</li>
              ))}
            </ul>
          </div>
          <div className="flex justify-start md:justify-end gap-2 md:gap-4">
            <a
              href={props.github}
              target="_blank"
              rel="noreferrer"
              whileHover={{
                scale: 1.1,
                color: "white",
                boxShadow: "0px 0px 8px rgb(255, 255, 255)",
              }}
            >
              <motion.img
                src={githubb}
                alt=""
                className="md:w-[30px] w-[20px]  "
                whileHover={{
                  scale: 1.1,
                  color: "white",
                  boxShadow: "0px 0px 8px rgb(255, 255, 255)",
                }}
              />
            </a>
            <a href={props.host} target="_blank" rel="noreferrer">
              <motion.img
                src={external}
                alt=""
                className="md:w-[30px] w-[20px] "
                whileHover={{
                  scale: 1.1,
                  color: "white",
                  boxShadow: "0px 0px 8px rgb(255, 255, 255)",
                }}
              />
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Projects;
